import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { getLocalization } from "../../redux/localization";
import RegisterFree from "../RegisterFree";

const FooterTop = () => {
  const t = useSelector(getLocalization);
  return (
    <section className="footerTopComponent">
      <Container>
        <Row>
          <Col md={12}>
            <div className="footerTop">
              <h2>{t.getString("Ready to get started")}</h2>
              <h3>
                {t.getString("Create your freemium account and start using it")}
              </h3>
              <RegisterFree />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default FooterTop;
